import React from 'react';
import { CircularProgress, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import './Modal.scss';
import CustomButtonWithIcon from "../../../../../components/CustomButtonWithIcon/Buttons";

const DeleteConfirmationModal = ({ open, onClose, onConfirm, groupName, loading, error }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle sx={{ textTransform: 'uppercase', fontWeight:'500', fontFamily:'inter', fontSize:'14px' }}>Delete Group</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to delete the group "{groupName}"? This action will move the hotels to the ungrouped list.
                </DialogContentText>

                {/* Error message in red, if any */}
                {error && <p style={{ color: 'red' }}>{error}</p>}
            </DialogContent>
            <DialogActions>
                {/* Display loader instead of buttons while waiting for the response */}
                {loading ? (
                    <CircularProgress size={24} />
                ) : (
                    <>
                        <div
                            className="button-container"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                gap: '16px', // Adjust gap size as needed
                            }}
                        >
                            <CustomButtonWithIcon
                                color="#b0acac"
                                hoverColor="#12794F"
                                titleColor="#373F41"
                                hoverTitleColor={"white"}
                                width={"85px"}
                                height={"24px"}
                                borderRadius="20px"
                                textStyle={{
                                    fontFamily: 'Inter',
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    lineHeight: '14.52px',
                                    textAlign: 'center',
                                }}
                                onClick={onClose}
                            >
                                Cancel
                            </CustomButtonWithIcon>
                            <CustomButtonWithIcon
                                color="#b0acac"
                                hoverColor="#12794F"
                                titleColor="#373F41"
                                hoverTitleColor={"white"}
                                width={"85px"}
                                height={"24px"}
                                borderRadius="20px"
                                textStyle={{
                                    fontFamily: 'Inter',
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    lineHeight: '14.52px',
                                    textAlign: 'center',
                                }}
                                onClick={onConfirm}
                            >
                                Delete
                            </CustomButtonWithIcon>
                        </div>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmationModal;
